// extracted by mini-css-extract-plugin
export default {"content":"DemographicQuestionSlide_content__Nuy4U"};